import styled from '@emotion/native';
import type { ColorName } from '@emotion/react';
import { Row } from 'components/base';
import { Icon, type IconName } from 'design-system';
import { BASE_SIZE, BORDER_WIDTH, PADDING } from 'design-system/theme';
import { router, usePathname } from 'expo-router';
import type * as React from 'react';

// Props accepted by the view
type TabNavigationConfig = {
  name?: string;
  initials?: string;
};

const BottomBarContainer = styled(Row)(({ theme }) => () => {
  return {
    backgroundColor: theme.color['base-grey'],
    alignItems: 'flex-start',
    justifyContent: 'center',
    paddingHorizontal: PADDING.s,
    maxWidth: '100%',
    borderStyle: 'solid',
    borderWidth: 0,
    borderColor: theme.color.divider,
    borderTopWidth: BORDER_WIDTH[1],
  };
});

export const Bottombar: React.FC<TabNavigationConfig> = () => {
  const currentRouteName = usePathname();

  return (
    <BottomBarContainer unsetZIndex>
      <Tab
        isActive={currentRouteName === '/'}
        icon="home"
        onPress={() => router.push('/')}
      />
      <Tab
        isActive={currentRouteName === '/patient'}
        icon="people-outline"
        onPress={() => router.push('patient')}
      />
      <Tab
        isActive={currentRouteName === '/admin'}
        icon="settings"
        onPress={() => router.push('admin')}
      />
    </BottomBarContainer>
  );
};

const Pressable = styled.Pressable<PressableProps>(({ theme, isActive }) => ({
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: BASE_SIZE[56],
  paddingHorizontal: PADDING.xs,
  paddingTop: PADDING['3xs'],
  borderStyle: 'solid',
  borderColor: isActive ? theme.color.primary : 'transparent',
  borderWidth: 0,
  borderBottomWidth: BORDER_WIDTH[2],
  width: 86,
}));

export const Tab: React.FC<TabProps> = ({ isActive, onPress, icon }) => {
  const color: ColorName = isActive ? 'primary' : 'text-default';

  return (
    <Pressable onPress={onPress} isActive={isActive}>
      <Icon color={color} name={icon} size={BASE_SIZE[24]} />
    </Pressable>
  );
};

interface TabProps {
  isActive: boolean;
  icon: IconName;
  onPress: () => void;
}

interface PressableProps {
  isActive: boolean;
}
